import { Link, useLocation } from "react-router-dom";
import { Home, Compass, Smile, User, Users } from "lucide-react";
import PathFinderAvatar from "@/components/PathFinderAvatar";

const NAV_ITEMS = [
  { path: "/compass", label: "Home", icon: Home },
  { path: "/discover", label: "Discover", icon: Compass },
  { path: "/community", label: "Community", icon: Users },
  { path: "/reflections", label: "Reflections", icon: Smile },
  { path: "/profile", label: "Profile", icon: User },
];

export const BottomNavigation = () => {
  const location = useLocation();

  return (
    <>
      {/* Bottom navigation */}
      <nav className="fixed bottom-0 left-0 right-0 z-50 pb-safe" data-testid="bottom-nav">
      <div className="mx-2 sm:mx-4 mb-4">
        <div className="bg-[#f5f9f5]/95 backdrop-blur-xl rounded-full px-1 sm:px-3 py-2 shadow-lg border border-[#c5d5c5]">
          <div className="flex items-center justify-evenly">
            {NAV_ITEMS.map((item) => {
              const isActive = location.pathname === item.path || 
                (item.path === "/compass" && location.pathname === "/weekly-reset");
              
              return (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`flex flex-col items-center gap-0.5 px-1.5 sm:px-2 py-1.5 sm:py-2 rounded-full transition-all duration-300 ${
                    isActive
                      ? "bg-[#7a9e7a] text-white"
                      : "text-[#5a7a6a] hover:text-[#2d4a47]"
                  }`}
                  data-testid={`nav-${item.label.toLowerCase()}`}
                >
                  <item.icon 
                    className={`w-5 h-5 transition-transform duration-300 ${isActive ? "scale-110" : ""}`} 
                    strokeWidth={isActive ? 2.5 : 2} 
                  />
                  <span className="font-medium" style={{ fontSize: '9px' }}>
                    {item.label}
                  </span>
                </Link>
              );
            })}
            
            {/* PathFinder Coach - Visible to ALL users */}
            <Link
              to="/pathfinder"
              className={`flex flex-col items-center gap-0.5 px-1.5 sm:px-2 py-1.5 sm:py-2 rounded-full transition-all duration-300 ${
                location.pathname === "/pathfinder"
                  ? "bg-[#7a9e7a] text-white"
                  : "text-[#5a7a6a] hover:text-[#2d4a47]"
              }`}
              data-testid="nav-pathfinder"
            >
              <PathFinderAvatar 
                size={20} 
                className={`transition-transform duration-300 ${location.pathname === "/pathfinder" ? "scale-110" : ""}`}
              />
              <span className={`font-medium ${location.pathname === "/pathfinder" ? "!text-white" : ""}`} style={{ fontSize: '9px' }}>
                PathFinder
              </span>
            </Link>
          </div>
        </div>
      </div>
    </nav>
    </>
  );
};

export default BottomNavigation;
